import { Component, HostListener, OnInit } from '@angular/core';
import { SharedService, CommonService, CommonAPIService } from '../../../services';
import { Paths } from '../../../enums';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header',
  standalone: false,
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent implements OnInit {
  isSticky: boolean = false;
  classApplied = false;
  getActiveCategoryData: any[] = [];
  courseCategoryData: any[] = [];

  constructor(
    private sharedService: SharedService,
    private commonService: CommonService,
    private commonAPIService: CommonAPIService,
    private router: Router
  ) { }

  @HostListener('window:scroll', ['$event'])
  checkScroll() {
    const scrollPosition = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0;
    if (scrollPosition >= 50) {
      this.isSticky = true;
    } else {
      this.isSticky = false;
    }
  }

  ngOnInit() {
    this.getGalleryCategoryList();
  }

  toggleClass() {
    this.classApplied = !this.classApplied;
  }

  getGalleryList(data: any) {
    this.commonAPIService.data = data;
    this.router.navigate([`${Paths.events}`]);
  }

  getCourseSubCategoty(data: any) {
    this.commonAPIService.data = data;
    this.router.navigate([`${Paths.courseSubCategory}`]);
  }

  async getGalleryCategoryList() {
    try {
      this.sharedService.setApiCall(true);
      this.commonService.resetAPIFlag('getActiveCategory', false);
      const response: any = await this.commonAPIService.getCall('getActiveCategory', '');
      this.commonService.resetAPIFlag('getActiveCategory', false);
      switch (response.status) {
        case 1:
          if (response.data) {
            this.getActiveCategoryData = response?.data;
            this.sharedService.setApiCall(false);
            this.getCoursesCategoryList();
          } else {
            this.getActiveCategoryData = [];
            this.sharedService.setApiCall(false);
          }
          break;
        case 0:
          this.getActiveCategoryData = [];
          this.sharedService.setApiCall(false);
          break;
      }
    } catch (error) {
      console.error('Error getting list:', error);
    }
  }

  async getCoursesCategoryList() {
    try {
      this.sharedService.setApiCall(true);
      this.commonService.resetAPIFlag('getCoursesCategoryActive', false);
      const response: any = await this.commonAPIService.getCall('getCoursesCategoryActive', '');
      this.commonService.resetAPIFlag('getCoursesCategoryActive', false);
      switch (response.status) {
        case 1:
          if (response.data) {
            this.courseCategoryData = response?.data;
            this.sharedService.setApiCall(false);
          }
          else {
            this.courseCategoryData = [];
            this.sharedService.setApiCall(false);
          }
          break;
        case 0:
          this.courseCategoryData = [];
          this.sharedService.setApiCall(false);
          break;
      }
    } catch (error) {
      console.error('Error getting Courses details:', error);
    }
  }
}
